

import { storage } from "@/firebase"
import compressor from "@/utils/CompressorFile.js"

const uploadImg = async (register, file) => {
    const fileCompress = await compressor.compressorFile(file)
    const imgNameSaved = new Date().getTime() +"_"+file.name
    const pathSaved = `water_scan_imgs/${register}/${imgNameSaved}`
    const storageWS_REF = storage.ref(pathSaved)
    var task = storageWS_REF.put(fileCompress);
    await new Promise((resolve, reject) => {
        task.on('state_changed',
            function progress(snapshot) {
                var percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
            },
            function error(err) {
                console.error(`uploadImg - ${err}`)
                reject(err)
            },
            function complete() {
                var downloadURL = task.snapshot.downloadURL;
                resolve("Download Complet")
            }
        );
    })
    return pathSaved
}
const uploadDiagnosticImgProject = async (project_id, file) => {
    const fileCompress = await compressorFile(file)
    const imgNameSaved = new Date().getTime() +"_"+file.name
    const pathSaved = `projects/${project_id}/Diagnostic/${imgNameSaved}`
    const storageWS_REF = storage.ref(pathSaved)
    var task = storageWS_REF.put(fileCompress);
    await new Promise((resolve, reject) => {
        task.on('state_changed',
            function progress(snapshot) {
                var percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
            },
            function error(err) {
                reject(err)
            },
            function complete() {
                var downloadURL = task.snapshot.downloadURL;
                resolve("Download Complet")
            }
        );
    })
    return pathSaved
}
const downloadImg = async (path) => {
    return storage.ref(path).getDownloadURL() 
}
const deleteImg = async (path) => {
    try{
        await storage.ref(path).delete()
    }catch(err){
        console.error(`Error - deleteImg ${err}`)
    }
}

export default {
    uploadImg,
    deleteImg,
    downloadImg,
    uploadDiagnosticImgProject,
}